import type { FormikProps } from 'formik'
import type { FunctionComponent } from 'react'

import Slider from '@material-ui/core/Slider'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import { getIn } from 'formik'
import styled from 'styled-components'

const SliderContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 99%;
	align-self: center;
	gap: 24px;
`

interface QuestionSliderProps {
	fieldName: string
	formProps: FormikProps<any>
	min?: number
	max?: number
	step?: number
	label?: string
	marks?: { value: number; label: string }[]
}

export const SliderQuestion: FunctionComponent<QuestionSliderProps> = ({
	fieldName,
	formProps,
	min = 0,
	max = 100,
	step = 1,
	label,
	marks: customMarks,
}) => {
	const marks = customMarks || false

	const CustomSlider = createTheme({
		overrides: {
			MuiSlider: {
				root: {
					color: '#4f6bd5',
					height: 8,
				},
				thumb: {
					height: 20,
					width: 20,
					backgroundColor: '#fff',
					border: '2px solid currentColor',
					marginTop: -8,
					marginLeft: -12,
					'&:focus, &:hover, &$active': {
						boxShadow: 'inherit',
					},
				},
				active: {},
				valueLabel: {
					left: 'calc(-50% + 4px)',
					top: -22,
					'& *': {
						background: 'transparent',
						color: '#000',
					},
				},
				track: {
					height: 8,
					borderRadius: 4,
				},
				rail: {
					height: 8,
					borderRadius: 4,
				},
				markLabel: {
					color: '#000',
					fontSize: '0.75rem',
					top: '38px',
					'&[data-index="0"]': {
						transform: 'translateX(0)',
					},
					'&[data-index="1"]': {
						transform: 'translateX(-100%)',
					},
				},
				mark: {
					display: 'none',
				},
			},
		},
	})

	return (
		<SliderContainer>
			<div>{label}</div>
			<ThemeProvider theme={CustomSlider}>
				<Slider
					defaultValue={min}
					valueLabelDisplay="on"
					step={step}
					min={min}
					max={max}
					marks={marks}
					onChange={(_event, value) => {
						formProps.setFieldValue(fieldName, value)
					}}
					value={getIn(formProps.values, fieldName) || min}
				/>
			</ThemeProvider>
		</SliderContainer>
	)
}
